import App from '../../app';
import EmbedProgramGuide from './EmbedProgramGuide';

const Modules = {
    EmbedProgramGuide
}

App.init(Modules);
